import { FaInstagram } from "react-icons/fa";
import { PrimaryButton } from "./PrimaryButton";

export const InstagramSection = () => {
  const instagramPosts: { href: string; src: string }[] = [
    {
      href: "/ergotherapie_rottweil/p/DQTa_ODCEku/",
      src:
        "https://scontent-fra3-1.cdninstagram.com/v/t51.82787-15/572484096_17899941780314236_2967806378942145530_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=103&ig_cache_key=Mzc1MjQ2MTYwODE0OTMzODQxNA%3D%3D.3-ccb1-7&ccb=1-7&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEzNTB4MTY4OC5zZHIuQzMifQ%3D%3D&_nc_ohc=fHv5szE-_egQ7kNvwFa2Qda&_nc_oc=AdmF_HIVUwGIRB2XmX-qMQ94aBU1lU7G3PEIyIrTgTScNC2Y169lVNCmlIfr9SWIhg815h5YRwxfukC2LAv7Jkms&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent-fra3-1.cdninstagram.com&_nc_gid=Pa4yrRWJSGY4JfhIkpNFlA&oh=00_Aff1pshkPLlu7Pdb5yByRFeyHKcdKVjkMWfUvn_6LI6_nA&oe=69081119",
    },
    {
      href: "/ergotherapie_rottweil/p/DF9iAe8s_J1/",
      src:
        "https://scontent-fra3-1.cdninstagram.com/v/t51.75761-15/479377860_17868227550314236_59664564574896370_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=108&ig_cache_key=MzU2NjE1NjA0Njc1OTM1OTA5Mw%3D%3D.3-ccb1-7&ccb=1-7&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEzNTB4MTY4OC5zZHIuQzMifQ%3D%3D&_nc_ohc=k5Z6dUqqAnsQ7kNvwG74ZTc&_nc_oc=AdmXAPfiVnUcpv5xA5512QNhHIWxT5qFetJQ74DTWMDhHMcyDTYBFk51qzuyOrW-JTYLnjUG2VY9mQTLNh2Dg_zA&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent-fra3-1.cdninstagram.com&_nc_gid=Pa4yrRWJSGY4JfhIkpNFlA&oh=00_AfcR_vq1QN0YnBknVOhiDeRu0-MFgpdpuJ2qHMl7AK3POg&oe=69080B90",
    },
    {
      href: "/ergotherapie_rottweil/p/DF2EZV5M37Q/",
      src:
        "https://scontent-fra3-2.cdninstagram.com/v/t51.75761-15/476754023_17867836698314236_1661836084887745280_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=111&ig_cache_key=MzU2NDA1NTQ4ODc5MTU0MzUwNA%3D%3D.3-ccb1-7&ccb=1-7&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEzNTB4MTY4OC5zZHIuQzMifQ%3D%3D&_nc_ohc=ltxVRNcWkHsQ7kNvwGfH1po&_nc_oc=AdmHTa1yyhYSKrKYnZmfA4U3to9rIm1CIhlCb8JLG4FAmXOfOJOkP-WHXhbTNmGZhQCVMdc5bFQqrQT7_1Cx4EUC&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent-fra3-2.cdninstagram.com&_nc_gid=Pa4yrRWJSGY4JfhIkpNFlA&oh=00_Afd8GGpQqxXh4VehBxHMqKiAvaSI8tHA1Gxzb2dYIlYUVQ&oe=6907F75A",
    },
    {
      href: "/ergotherapie_rottweil/p/DFSIkWtsV31/",
      src:
        "https://scontent-fra3-1.cdninstagram.com/v/t51.75761-15/474930800_17866090902314236_3858062683297492634_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=108&ig_cache_key=MzU1Mzk0MDczODYxMDkxMjc1Nw%3D%3D.3-ccb1-7&ccb=1-7&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEzNTB4MTY4OC5zZHIuQzMifQ%3D%3D&_nc_ohc=zaSlD0-mD7IQ7kNvwHI1PBR&_nc_oc=Adl3ttDiPm2WHSsMi38hfEjSijflOrYxjF-7iJj85CZt6MPjxb9_1tFrk7f2j1ZdNqNWBiTz-iwv6C9YHow7_Z_S&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent-fra3-1.cdninstagram.com&_nc_gid=Pa4yrRWJSGY4JfhIkpNFlA&oh=00_Affl-ijOD2mQLOEHuQhoKBvgqV7pPUxEKwXdqpJrArh-OQ&oe=690806C4",
    },
    {
      href: "/ergotherapie_rottweil/p/DEO2j6aMlsm/",
      src:
        "https://scontent-fra3-2.cdninstagram.com/v/t51.29350-15/470910356_573004808895971_3381591038177997071_n.jpg?stp=dst-jpg_e35_tt6&efg=eyJ2ZW5jb2RlX3RhZyI6IkZFRUQuaW1hZ2VfdXJsZ2VuLjEzNTB4MTY4Ny5zZHIuZjI5MzUwLmRlZmF1bHRfaW1hZ2UuYzIifQ&_nc_ht=scontent-fra3-2.cdninstagram.com&_nc_cat=111&_nc_oc=Q6cZ2QEWjBC4AWnwPpNquW7zlwERmhzsT-BN5lhc2kYBiqoDlIv7jmITXVF1sJZ6wlIkPqjFJ6Fo87NUdl5agsJELOlH&_nc_ohc=MCRe70-csdkQ7kNvwFuDkhs&_nc_gid=Pa4yrRWJSGY4JfhIkpNFlA&edm=AP4sbd4BAAAA&ccb=7-5&ig_cache_key=MzUzNTAwMjcxOTk0MjIzNjk2Ng%3D%3D.3-ccb7-5&oh=00_Aff3_pvIfEVHQzCs-ic6zFNEm6W1Rwq2E_UzODC-xRLnSA&oe=69080AD7&_nc_sid=7a9f4b",
    },
    {
      href: "/ergotherapie_rottweil/p/DB8GKxXMfvr/",
      src:
        "https://scontent-fra5-1.cdninstagram.com/v/t51.29350-15/465802594_524697723866698_7036472073388007175_n.jpg?stp=dst-jpg_e35_tt6&efg=eyJ2ZW5jb2RlX3RhZyI6IkNBUk9VU0VMX0lURU0uaW1hZ2VfdXJsZ2VuLjE0NDB4MTgwMC5zZHIuZjI5MzUwLmRlZmF1bHRfaW1hZ2UuYzIifQ&_nc_ht=scontent-fra5-1.cdninstagram.com&_nc_cat=110&_nc_oc=Q6cZ2QEWjBC4AWnwPpNquW7zlwERmhzsT-BN5lhc2kYBiqoDlIv7jmITXVF1sJZ6wlIkPqjFJ6Fo87NUdl5agsJELOlH&_nc_ohc=kGxGMMS2AmEQ7kNvwHdbVFw&_nc_gid=Pa4yrRWJSGY4JfhIkpNFlA&edm=AP4sbd4BAAAA&ccb=7-5&ig_cache_key=MzQ5MzY5NDUzMDI5OTA4ODk4NQ%3D%3D.3-ccb7-5&oh=00_AfeaCArQ6VKn4QXYHZRe0bAOoyCYIfBwNOcgO7Og55cIiw&oe=69080BC2&_nc_sid=7a9f4b",
    },
  ];
  return (
    <div className="relative">
      <div className="px-6 pt-8 sm:px-8 lg:px-12">
        <div className="relative mx-auto">
          {/* Card Container */}
          <div
            className="relative backdrop-blur-sm bg-white/70 dark:bg-gray-900/70 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] 
            border border-ergo-100/60 dark:border-gray-700 p-12"
          >
            {/* Header Section */}
            <div className="text-center space-y-8">
              {/* Instagram Icon */}
              <div className="flex justify-center">
                <div
                  className="p-4 rounded-xl bg-ergo-100/80 dark:bg-ergo-900/80 
                  shadow-[0_8px_20px_rgb(139,211,230,0.2)] transform hover:scale-105 transition-all duration-300"
                >
                  <FaInstagram className="h-7 w-7 text-ergo-600 dark:text-ergo-400" />
                </div>
              </div>

              {/* Text Content */}
              <div className="space-y-4">
                <h2 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">
                  Folgen Sie uns auf Instagram
                </h2>
                <p className="text-base text-gray-600 dark:text-gray-300 max-w-xl mx-auto font-medium">
                  Bleiben Sie auf dem Laufenden über unsere Praxis und erhalten Sie wertvolle Tipps.
                </p>
              </div>

              {/* Preview grid */}
              <div className="mx-auto max-w-4xl">
                <div className="mb-2 grid grid-cols-2 sm:grid-cols-4 gap-2">
                  {instagramPosts.slice(0, 4).map((post, idx) => (
                    <a
                      key={idx}
                      href={`https://www.instagram.com${post.href}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-800"
                      aria-label={`Instagram Beitrag ${idx + 1}`}
                    >
                      <img
                        src={post.src}
                        alt="Instagram Vorschau"
                        className="w-full h-full object-cover aspect-square transition-transform duration-300 hover:scale-105"
                        loading="lazy"
                      />
                    </a>
                  ))}
                </div>
              </div>

              {/* Follow Button */}
              <div className="pt-4">
                <PrimaryButton
                  href="https://www.instagram.com/ergotherapie_rottweil"
                  className="shadow-[0_8px_20px_rgb(139,211,230,0.2)] hover:shadow-[0_12px_30px_rgb(139,211,230,0.3)]
                    dark:shadow-[0_8px_20px_rgb(139,211,230,0.1)] dark:hover:shadow-[0_12px_30px_rgb(139,211,230,0.2)]"
                >
                  <div className="flex items-center gap-x-3">
                    <FaInstagram className="h-5 w-5" />
                    <span className="font-semibold tracking-wide">Auf Instagram folgen</span>
                  </div>
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
